"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TITLE_SIZE = exports.SECTION_ELEMENT_ID = exports.ARROW_POSITION = void 0;
var SECTION_ELEMENT_ID = /*#__PURE__*/function (SECTION_ELEMENT_ID) {
  SECTION_ELEMENT_ID["content"] = "content";
  SECTION_ELEMENT_ID["heading"] = "heading";
  return SECTION_ELEMENT_ID;
}({});
exports.SECTION_ELEMENT_ID = SECTION_ELEMENT_ID;
var TITLE_SIZE = /*#__PURE__*/function (TITLE_SIZE) {
  TITLE_SIZE["default"] = "default";
  TITLE_SIZE["large"] = "large";
  return TITLE_SIZE;
}({});
exports.TITLE_SIZE = TITLE_SIZE;
var ARROW_POSITION = /*#__PURE__*/function (ARROW_POSITION) {
  ARROW_POSITION["left"] = "left";
  ARROW_POSITION["right"] = "right";
  return ARROW_POSITION;
}({});
exports.ARROW_POSITION = ARROW_POSITION;